<template>
  <div>
    <el-form size="small">
      <el-row :gutter="10">
        <el-col :span="10">
          <!--操作时间-->
          <el-form-item :label="$t('GlobalSetObj.operationTime')">
            <el-date-picker
              v-model="timeArr"
              :clearable="true"
              :default-time="['00:00:00', '23:59:59']"
              :format="$i18n.locale==='zh'?zhDate:ptDate"
              :placeholder="$t('newOrder.SelectDatetime')"
              :start-placeholder="$t('collectionCenter.StartTime')"
              :end-placeholder="$t('collectionCenter.EndTime')"
              range-separator="~"
              style="width:100%"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <!--袋号-->
          <el-form-item :label="$t('mdfeTranslate.PackageNumber')">
            <el-input
              v-model="queryForm.params.waybillNumber"
              :placeholder="$t('collectionCenter.pleaseInput')"
              style="width:100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <div style="margin-top: 30px;">
            <!--查询-->
            <el-button
              type="primary"
              size="small"
              @click="handleQuery"
            >
              {{ $t('collectionCenter.search') }}
            </el-button>
            <!--重置-->
            <el-button size="small" @click="onReset">
              {{ $t('collectionCenter.reset') }}
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div v-if="rowData.status !== 2" style="margin-bottom: 10px;">
      <el-button
        type="primary"
        size="small"
        @click="removeBag"
      >
        {{ $t('compensationManagement.Remove') }}
      </el-button>
    </div>
    <div>
      <el-table
        :data="tableData"
        border
        :header-cell-style="{background:'#ebebeb',color:'#000'}"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
          fixed="left"
        />
        <el-table-column
          :label="$t('CenterForSorting.ind')"
          align="center"
          width="80px"
          fixed="left"
        >
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('mdfeTranslate.PackageNumber')"
          align="center"
          prop="waybillNumber"
        />
        <el-table-column
          :label="$t('GlobalSetObj.operationTime')"
          align="center"
          prop="operationTime"
        />
        <el-table-column
          :label="$t('collectionCenter.operator')"
          align="center"
          prop="operationName"
        />
      </el-table>
      <el-pagination
        :current-page="queryForm.pageNumber"
        :page-size="queryForm.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: 10px 0;float: right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!--提示-->
    <el-dialog
      :title="$t('collectionCenter.tips')"
      :visible.sync="showRemoveWindow"
      width="600px"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="5%"
    >
      <div>
        <div style="margin-bottom: 20px;font-size: 18px">
          {{ $t('collectionCenter.PleaseConfirmRemovalPackageNumber') }}
        </div>
        <div style="height: 300px;overflow-y: auto;">
          <div v-for="(item,index) in selectedData" :key="index" style="margin-bottom: 10px;">{{ item.waybillNumber }}</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          size="small"
          @click="handleRemoveConfirm"
        >
          {{ $t('collectionCenter.Confirm') }}
        </el-button>
        <el-button size="small" @click="showRemoveWindow = false">{{ $t('collectionCenter.close') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import { queryCollectCodeDetailPage, removePackage } from '@/api/automaticSorting';

export default {
  name: 'PackageNumber',
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          consolidateCodeId: null,
          numberType: 1,
          bagNumber: null,
          waybillNumber: null,
          startTime: null,
          endTime: null
        }
      },
      total: 0,
      timeArr: [],
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      tableData: [],
      selectedData: [],
      showRemoveWindow: false
    };
  },
  created() {
    this.handleQuery();
  },
  methods: {
    // 查询
    handleQuery() {
      this.queryForm.pageNumber = 1;
      this.getTableData();
    },
    onReset() {
      this.timeArr = [];
      this.queryForm.params.bagNumber = null;
      this.queryForm.params.startTime = null;
      this.queryForm.params.waybillNumber = null;
      this.queryForm.params.endTime = null;
      this.queryForm.params.consolidateCodeId = null;
      this.queryForm.params.numberType = 1;
      this.getTableData();
    },
    // 获取数据
    getTableData() {
      const params = {
        pageNumber: this.queryForm.pageNumber,
        pageSize: this.queryForm.pageSize,
        params: {
          consolidateCodeId: this.rowData.id,
          numberType: 1,
          bagNumber: null,
          waybillNumber: this.queryForm.params.waybillNumber,
          startTime: null,
          endTime: null
        }
      };
      if (Array.isArray(this.timeArr) && this.timeArr.length === 2) {
        params.params.startTime = this.timeArr[0];
        params.params.endTime = this.timeArr[1];
      } else {
        params.params.startTime = null;
        params.params.endTime = null;
      }
      queryCollectCodeDetailPage(params).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    handleSelectionChange(val) {
      this.selectedData = val;
    },
    removeBag() {
      if (this.selectedData.length === 0) {
        this.$message.error(this.$t('orderCenterCont.SelectAtLeastOnePieceOfData'));
        return;
      }
      console.log(this.selectedData);
      this.showRemoveWindow = true;
    },
    // 确认移除
    handleRemoveConfirm() {
      const param = {
        detailList: [],
        consolidateCodeId: this.rowData.id,
        consolidateCode: this.rowData.code,
        numberType: 1,
        userId: this.$store.state.user.id
      };
      this.selectedData.map(item => {
        const itemData = {
          id: item.id,
          declaredValue: item.declaredValue,
          number: item.waybillNumber,
          weight: item.weight
        };
        param.detailList.push(itemData);
      });
      removePackage(param).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
          this.showRemoveWindow = false;
          this.handleQuery();
          this.bus.$emit('updateTableData');
        }
      });
    },
    // 每页显示数量变化
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getTableData();
    },
    // 翻页
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getTableData();
    }
  }
};
</script>
<style scoped>

</style>

